import React from 'react'

import { routes } from '@sketch/constants'
import { LinkButton } from '@sketch/components'

import { Banner } from './WorkspaceSettingsSubscribePanel.styles'

interface WorkspaceSettingsSubscribePanelProps {
  workspaceId: string
}

export const WorkspaceSettingsSubscribePanel: React.FC<WorkspaceSettingsSubscribePanelProps> = ({
  workspaceId,
}) => (
  <Banner
    title="Enjoying Sketch?"
    text={
      <span>
        To keep using this Workspace after the trial ends, set up a
        subscription.
      </span>
    }
    action={
      <LinkButton
        to={routes.WORKSPACE_SUBSCRIBE.create({
          workspaceId,
        })}
        variant="primary-untinted"
        size="40"
      >
        Subscribe to Sketch
      </LinkButton>
    }
  />
)
